import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { checkPermissionStatus } from "helpers/utils";
import { FetchOrganizationById } from "services/OrganizationServices";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import pencil from "../../assets/images/icon/pencil.svg";
import location from "../../assets/images/icon/location.svg";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import DataFetchLoader from "components/Common/DataFetchLoader";
import SPOC from "./SPOC/SPOC";
import EditOrganizationModal from "./EditOrganizationModal";

const ViewOrganization = ({ ...props }) => {
  const { t } = useTranslation();
  const params = useParams();

  const [loading, setLoading] = useState(false);
  const [orgDetails, setOrgDetails] = useState(null);

  const [editModal, setEditModal] = useState(false);
  const [editDetails, setEditDetails] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      let response = await FetchOrganizationById(params?.id);

      let responseData = decryptDataFromArray(response);

      setOrgDetails(responseData?.organization);
      setLoading(false);
    } catch (error) {
      toast.error(t(`Organization.Organization Not Found`));
      setOrgDetails(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    return () => {};
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("organization", "view")) {
    return (
      <>
        <div className="page-content">
          <h4 className="text-center">{t(`Profile.Access Denied`)}</h4>
        </div>
      </>
    );
  }

  if (loading) {
    return <DataFetchLoader loading={loading} />;
  }

  return (
    <>
      <div className="page-content departmentpage">
        <Container fluid>
          <div className="joblist-container create-vacancy">
            <Row className="align-items-center  py-2 pt-0">
              <Col lg="6" md="6" className="Joblist-column viewOrg">
                <div
                  role="button"
                  onClick={() => {
                    if (typeof props?.history?.goBack === "function") {
                      props?.history?.goBack();
                    } else {
                      props?.history?.push("/organization");
                    }
                  }}
                >
                  <h5 className="text-uppercase heading-one spece-low-cum2">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Organization.Organization Details`)}
                  </h5>
                </div>
              </Col>
            </Row>
          </div>

          <div className="outerTab-box-wrapper below-vacancy  ui-modification">
            <div className="user-details-cards cards-section cadidate-details">
              <div className="user-details-content w-100">
                <div
                  role="button"
                  onClick={() => {
                    setEditDetails(orgDetails);
                    setEditModal(true);
                  }}
                >
                  <div className="edit-pen-details">
                    <span>
                      <img src={pencil} alt="pencil/" />
                    </span>
                    <h6>{t(`Organization.Edit Organization`)}</h6>
                  </div>
                </div>

                <div className="user-details-card persoal-names">
                  <h4>{orgDetails?.name}</h4>
                </div>

                <div class="card-table-details w-100">
                  <div class="personalInfo-details d-flex mt-3 w-100">
                    <div class="personal-info">
                      <span>
                        <img src={location} alt="address" />
                      </span>
                      <div class="perosonal-card-info">
                        <h4>{t(`Organization.Address`)}:</h4>
                        <span className="text-transform-none">
                          {orgDetails?.address}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <EditOrganizationModal
            t={t}
            editModal={editModal}
            setEditModal={setEditModal}
            editOrgDetails={editDetails}
            setEditOrgDetails={setEditDetails}
            fetchData={fetchData}
          />

          {orgDetails?.id &&
          checkPermissionStatus("organization-spoc", "view") ? (
            <>
              <SPOC orgDetails={orgDetails} />
            </>
          ) : (
            <></>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewOrganization;
